export const nlFilter = /^[0-9]{4} {0,1}[a-zA-Z]{2}$/;
export const deFilter = /^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/;

export const postalCodeFilters = {
  nl: nlFilter,
  de: deFilter,
};
